import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import registerServiceWorker from './registerServiceWorker';
import * as firebase from 'firebase'

var config = {
    apiKey: "AIzaSyDr8tjw9i-5qw4r4S894A8U-gtVa2_BtGs",
    authDomain: "react-simon.firebaseapp.com",
    databaseURL: "https://react-simon.firebaseio.com",
    projectId: "react-simon",
    storageBucket: "react-simon.appspot.com",
    messagingSenderId: "676605838120"
};

firebase.initializeApp(config);

ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js